import { render } from "./Draggable.vue?vue&type=template&id=1c439d16&scoped=true"
import script from "./Draggable.vue?vue&type=script&lang=ts"
export * from "./Draggable.vue?vue&type=script&lang=ts"

import "./Draggable.vue?vue&type=style&index=0&id=1c439d16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c439d16"

export default script